export default __webpack_public_path__ + "static/media/move-material-6.9ff5767e.webp";